import {Controller} from "stimulus";
import $ from 'jquery'

export default class extends Controller {
    connect() {
//        Turbolinks.visit(window.location.toString(), { action: 'replace' });
        $('.organization-select').select2().on('select2:select', (e) => {
            let selectElement = document.getElementById('organization-select')
            let selectedValue = selectElement.value
            if (selectedValue) {
                let urlObject = new URL(window.location.href);
                if (urlObject.searchParams.has('journal_type') || urlObject.pathname.startsWith('/organizations/debug/')) {
                    urlObject.searchParams.set('org_id', selectedValue);
                    window.location.href = urlObject.toString();
                } else {
                    let url_split = window.location.href.split("/");
                    url_split[4] = selectedValue;
                    window.location.href = url_split.join("/");
                }
            }
        });
        $('.organization-select').on('select2:open', () => {
            $(".select2-search__field").attr("placeholder", "Search organization...");
            $(".select2-search__field")[0].focus();
        });
    }
}
